import { render, staticRenderFns } from "./GridText.vue?vue&type=template&id=05ab4aa9&"
import script from "./GridText.vue?vue&type=script&lang=js&"
export * from "./GridText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports